import request from '@/utils/request'


// 查询发现板块-用户频道列表
export function listDiscoverUserChannel(query) {
  return request({
    url: '/discovery/discover/user/channel/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询发现板块-用户频道分页
export function pageDiscoverUserChannel(query) {
  return request({
    url: '/discovery/discover/user/channel/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询发现板块-用户频道详细
export function getDiscoverUserChannel(data) {
  return request({
    url: '/discovery/discover/user/channel/detail',
    method: 'get',
    params: data
  })
}

// 新增发现板块-用户频道
export function addDiscoverUserChannel(data) {
  return request({
    url: '/discovery/discover/user/channel/add',
    method: 'post',
    data: data
  })
}

// 修改发现板块-用户频道
export function updateDiscoverUserChannel(data) {
  return request({
    url: '/discovery/discover/user/channel/edit',
    method: 'post',
    data: data
  })
}

// 删除发现板块-用户频道
export function delDiscoverUserChannel(data) {
  return request({
    url: '/discovery/discover/user/channel/delete',
    method: 'post',
    data: data
  })
}
